<template>

 	<b-container fluid class="mt-4 mx-25px p-0">

    <div class="accordion" role="tablist">

    <b-card class="text-center" v-if="dom === null">
      <template #header>
        
        <b-row>
          <h5 class="title_card">Mutation Information</h5>
          <i v-b-toggle.accordion-1 @click="activeMutTab = !activeMutTab" class="fa-2x fas" v-bind:class="[activeMutTab ? 'fa-caret-square-down' : 'fa-caret-square-up']"></i>
        </b-row>
      </template>
      <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">

        <mutation-table-component
          v-if="domSelected !== null"
          :dom-selected="domSelected"
          :entry-id="entryId"
        >
        </mutation-table-component>

      </b-collapse>
    </b-card>

    <b-card class="text-center" >
      <template #header>
        <b-row>
          <h5 class="title_card">HMM Logo</h5>
          <i v-b-toggle.accordion-2 @click="activeLogo = !activeLogo" class="fa-2x fas" v-bind:class="[activeLogo ? 'fa-caret-square-down' : 'fa-caret-square-up']"></i>
        </b-row>
      </template>
      <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">

        <hmm-component
          v-if="domSelected != null"
          :dom-selected="domSelected"
          :entry-id="entryId"
          :key="ck"
          :ck="ck"
          :dom="dom"
        >
        </hmm-component>

      </b-collapse>
    </b-card>
  
      <!-- <b-card class="text-center" >
        <template #header>
          <b-row>
            <h5 class="title_card">Human protein domains alignment</h5>

            <i v-b-toggle.accordion-3 @click="activeAlign = !activeAlign" class="fa-2x fas" v-bind:class="[activeAlign ? 'fa-caret-square-down' : 'fa-caret-square-up']"></i>
          </b-row>
        </template>
        <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">

        <b-row v-if="seqAlign == null ">
          <b-overlay :show="seqAlign == null" no-wrap></b-overlay>
        </b-row>
        <alignment-viewer-component
          v-if="seqAlign != null "
          :seq-align="seqAlign"
          :entry-id="entryId"
          :dom-selected="domSelected"
          :ck="ck">
        </alignment-viewer-component>

        </b-collapse>
      </b-card> -->
<!-- ici -->
      <b-card class="text-center" >
        <template #header>
          <b-row>
            <h5 class="title_card">Human protein domains alignment</h5>

            <i v-b-toggle.accordion-3 @click="activeAlign = !activeAlign" class="fa-2x fas" v-bind:class="[activeAlign ? 'fa-caret-square-down' : 'fa-caret-square-up']"></i>
          </b-row>
        </template>
        <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">

        <b-row v-if="seqAlignTest == null ">
          <b-overlay :show="seqAlignTest == null" no-wrap></b-overlay>
        </b-row>
        <alignment-viewer-component-test
          v-if="seqAlignTest != null "
          :seq-align-test="seqAlignTest"
          :entry-id="entryId"
          :dom-selected="domSelected"
          :ck="ck">
        </alignment-viewer-component-test>

        </b-collapse>
      </b-card>
<!-- ici -->
      <b-card class="text-center" >
        <template #header>
          <b-row>
            <h5 class="title_card">Domain Mutations Frequencies</h5>
            <i v-b-toggle.accordion-4 @click="activeFeature = !activeFeature" class="fa-2x fas" v-bind:class="[activeFeature ? 'fa-caret-square-down' : 'fa-caret-square-up']"></i>
          </b-row>
        </template>

        <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
          <b-card-body id="feature_viewer">
            <b-row v-if="seqInfo == null ">
              <b-overlay :show="seqInfo == null" no-wrap></b-overlay>
            </b-row>
   			    <feature-viewer-component
              ref="ftcomp"
   				     v-if="seqInfo != null "
   				     :seq-info="seqInfo"
                :entry-id="entryId"
                :data-display="dataDisplay"
                :key="ck"
   			    ></feature-viewer-component>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </b-container>
</template>
<script>
 	export default {
 		props: {
 			entryId: String,
 			domSelected: [String,Array],
      ck:Number,
      dom: String
 		},
 		data() {
 			return {
 				seqInfo: null,
        infoDom: null,
        test: null,
        posLogo: 0,
        seqAlign: null,
        seqAlignTest: null,
        activeMutTab: true,
        activeLogo: true,
        activeAlign: true,
        activeFeature: true,
        dataDisplay: {gene:'',prot_dom:''},
        // componentKey: 0
 			}
 		},
 		mounted() {
      console.log('BLOCK Component mounted.')

      this.format()
      this.get_seq_info()
      //this.get_alignment_2()
      this.get_alignment_3()
    },
    watch: {

    },
    computed:{
      displaydiv(){
        return {
          display : this.showdiv ? "block" : "none"
        }
      }
    },
    methods:{
    	async get_seq_info(){
        var truc = []        
        for (var i = 0; i < this.domSelected.length; i++) {
          truc[i] = this.domSelected[i].pfid
        }

    		let tab = [this.entryId, truc.join(',')]

    		axios
          .post("/main/get_seq_info", tab)
          .then( ({data}) => {
            this.seqInfo = data
            // ,console.log(data)   
          })
          .catch(error => console.log(error))
    	},
      // async get_alignment_2(){
      //   var pfids = []
      //   axios
      //     .post("/main/get_alignment_2",{data: this.domSelected, dom: this.dom})
      //     .then( ({data}) => {
      //       this.seqAlign = data   
      //     })
      //     .catch(error => console.log(error))
      // },
      async format(){
        let vm = this
        $.each(this.domSelected, function(k,v){
          if (k > 0) {
            vm.dataDisplay.prot_dom += ' and '
          }
          vm.dataDisplay.gene = v.gene;
          vm.dataDisplay.prot_dom += v.name_dom;
        });
      },
      async get_alignment_3(){
        var pfids = []
        axios
          .post("/main/get_alignment_3",{data: this.domSelected, dom: this.dom})
          .then( ({data}) => {
            this.seqAlignTest = data
          })
          .catch(error => console.log(error))
      }
    }
 	}

</script>

